module.exports = __webpack_public_path__ + "img/20180120_9.1c55584c.jpeg";